module.exports = __webpack_public_path__ + "img/banner-icon-2.706197f3.webp";